import React from 'react'
import { INTERAX_COLORS } from '../../constants/colors'
import { COMPONENT_DIMENSIONS } from '../../constants/layout'

export interface AvatarProps {
  name: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

// Function to extract initials from a name
const getInitials = (name: string): string => {
  if (!name || name.trim() === '') return '?'

  const words = name.trim().split(/\s+/)

  if (words.length === 1) {
    // Single name - take first two characters
    return words[0].substring(0, 2).toUpperCase()
  } else {
    // Multiple names - take first character of first two words
    return words
      .slice(0, 2)
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase()
  }
}

// Avatar size configurations using constants
const avatarSizes = {
  sm: {
    size: COMPONENT_DIMENSIONS.AVATAR_SM,
    textClass: 'text-sm'
  },
  md: {
    size: COMPONENT_DIMENSIONS.AVATAR_MD,
    textClass: 'text-base'
  },
  lg: {
    size: COMPONENT_DIMENSIONS.AVATAR_LG,
    textClass: 'text-lg'
  }
} as const

export const Avatar: React.FC<AvatarProps> = ({ name, size = 'md', className = '' }) => {
  const initials = getInitials(name)
  const avatarConfig = avatarSizes[size]

  return (
    <div
      className={`
        bg-sun border-2
        rounded-lg flex items-center justify-center 
        font-bold text-white ${avatarConfig.textClass}
        ${className}
      `}
      style={{
        width: `${avatarConfig.size}px`,
        height: `${avatarConfig.size}px`,
        borderColor: INTERAX_COLORS.blackTransparentBorder
      }}
    >
      {initials}
    </div>
  )
}

export default Avatar
